import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/material";
import ModalContainer from "components/ModalContainer";
import ModalLayout from "components/ModalLayout";
import PlayerCardCanvas from "components/PlayerCardCanvas";
import { sendMessageToCanvas } from "utils/miscUtils";
import { Tabs, Tab, TabPanel } from "components/Tab";

const useStyles = makeStyles((theme) => ({
  modalConatiner: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexFlow: "column nowrap",
    justifyContent: "start",
    alignItems: "center",
  },
  header: {
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "space-between",
    alignItems: "center",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
}));

const playerCardTab = 0,
  playerCardDetailsTab = 1;

const ViewFullCardModal = ({ cardDetails, isOpen, label, close }: any) => {
  const styles = useStyles();
  const [tab, setTab] = useState<number>(playerCardTab);
  const onTabChange = (e: any, v: number) => setTab(v);

  const sendToCanvas = (type, data, message) => {
    const iframe = document.getElementById("playerCard");

    if (!iframe) {
      console.log("playerCard iframe is not found");
      return;
    }

    sendMessageToCanvas(iframe, {
      message: message ?? "UPDATE_PLAYER",
      type: type === "INIT" ? "INIT" : type,
      data: data,
    });
  };

  useEffect(() => {
    // let timer
    // if (tab === 1) {
    //   timer = setTimeout(()=> sendToCanvas("PLAYER_DETAILS", cardDetails, "VIEW_PLAYER_DETAILS"), 100);
    // }
    // return () => clearTimeout(timer)
  }, [tab]);

  if (!cardDetails) return <></>;

  return (
    <ModalContainer openModel={isOpen} handleClose={close}>
      <ModalLayout isLargeContainer={true} padding={35}>
        <Box className={styles.modalConatiner}>
          <Tabs value={tab} onChange={onTabChange}>
            <Tab label="Player Card" value={playerCardTab} />
            <Tab label="Player Card Details" value={playerCardDetailsTab} />
          </Tabs>
          <TabPanel value={tab} index={0}>
            <PlayerCardCanvas
              playerDetails={cardDetails}
              sendToCanvas={sendToCanvas}
            />
          </TabPanel>
          <TabPanel value={tab} index={1}>
            <PlayerCardCanvas
              playerDetails={cardDetails}
              sendToCanvas={() =>
                sendToCanvas("INIT", cardDetails, "VIEW_PLAYER_DETAILS")
              }
            />
          </TabPanel>
        </Box>
      </ModalLayout>
    </ModalContainer>
  );
};

export default ViewFullCardModal;
